module.exports = __webpack_public_path__ + "img/grand-prize.771f7bc.png";